<template>
    <div class="container" :class="seasonClass">
        <div class="screen" :style="pageStyle">
          <div class="season2-logo">
            <img
                class="img"
                src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/logo.png"
                alt=""
            />
            <img
                class="img"
                src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season3/season3.png"
                alt=""
            />
          </div>
            <template>
                <div class="input-container">
                  <div class="info-title header info-title2">
                    <div class="cn">小组赛</div>
                    <div class="en">Group Competition</div>
                  </div>
                    <div class="title" style="margin-bottom: 0px;">
                        请输入你的比赛号码
                    </div>
                    <div class="title">Please enter your race number</div>
                    <el-input
                        class="input"
                        v-model="queryForm.examinationNumber"
                        type="number"
                        :readonly="dialogVisible"
                        placeholder="请输入比赛号码"
                    ></el-input>
                    <div class="button-group">
                        <div class="search" @click="getInfo">登录 | Login</div>
                    </div>
                </div>
            </template>
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :custom-class="seasonClass === 'season1' ? 'responsive-dialog' : 'season2-dialog responsive-dialog'"
            :width="getDialogWidth()"
        >
            <div class="info-panel info-panel-season2">
                <div class="info-title">
                    <div class="cn">请确认你的个人信息</div>
                    <div class="en word-break">
                        Please confirm your information.
                    </div>
                </div>
                <div class="info-con">
                    <div
                        class="info-item"
                        v-for="(value, key) in info"
                        :key="key"
                    >
                        <div class="key">
                            <div class="cn">{{ key }}</div>
                            <div class="en">{{ getEn(key) }}</div>
                        </div>
                        <div class="value">
                            {{ value }}
                        </div>
                    </div>
                </div>
                <div class="info-btns">
                    <div class="btn btn1" @click="closeFn">返回 | Cancel</div>
                    <div class="btn btn2" @click="confirmFn">
                        确认 | Confirm
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { saveSignStatus } from '@/http/wxApi'
import env from '@/http/env'

export default {
  data () {
    return {
      base: env.baseWebIP,
      seasonClass: 'season2',
      screenWidth: 0,
      screenHeight: 0,
      pageStyle: {
        width: '100%'
      },
      query: {},
      dict_district: [
        // {
        //   districtName: '上海赛区',
        //   id: '19'
        // },
        {
          districtName: '杭州赛区',
          id: '43'
        },
        {
          districtName: '天津赛区',
          id: '9'
        }
      ], // 赛区数据
      dict_grade: [
        { dictCode: '1', dictLabel: '一年级' },
        { dictCode: '2', dictLabel: '二年级' },
        { dictCode: '3', dictLabel: '三年级' },
        { dictCode: '4', dictLabel: '四年级' },
        { dictCode: '5', dictLabel: '五年级' },
        { dictCode: '6', dictLabel: '六年级' },
        { dictCode: '7', dictLabel: '七年级' },
        { dictCode: '8', dictLabel: '八年级' },
        { dictCode: '9', dictLabel: '九年级' }
      ], // 年级数据
      dict_group: [
        { dictCode: '1', cn: '小学组', en: 'Primary School' },
        { dictCode: '2', cn: '初中组', en: 'Junior High School' },
        { dictCode: '3', cn: '高中组', en: 'Senior High School' }
      ], // 组别数据
      examRooms: [], // 考场下拉列表
      loading: false,
      dialogVisible: false,
      info: {}, // 参赛者信息
      userId: '', // 参赛者ID
      userLevel: '', // 参赛者级别
      cnTitle: '汉英双拼大会',
      enTitle: 'Chinese English Bilingual Spelling Bee',
      padUserInfo: {}, // 参赛者信息
      isFull: false, // 是否全屏
      group: 1, // 有组别
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$route.query.season || '2024~2025',
        raceSchedule: this.$route.query.raceSchedule,
        examinationNumber: ''
      }
    }
  },
  created () {
  },
  methods: {
    getInfo () {
      if (!this.queryForm.examinationNumber) {
        this.$message.warning('请输入比赛号码')
        return
      }
      this.queryForm.examinationNumber = this.addZero(this.queryForm.examinationNumber)
      if (this.loading) return
      this.loading = true
      console.log('发送请求参数:', this.queryForm)
      this.$http.get(this.$env.wechatWebIP + 'common/examinationUser/selectByNationalMatchNum', { params: { matchNum: this.queryForm.examinationNumber } }).then(res => {
        console.log('接口返回数据:', res)
        if (res.code === 200 && res.data) {
          const obj = {}
          obj['姓 名'] = res.data.userName || '--'
          obj['手 机 号'] = res.data.phone || '--'
          obj['年 级'] = this.gradeFormatter(res.data.grade) || '--'
          obj['学 校'] = res.data.schoolName || '--'
          obj['比赛号码'] = res.data.matchNum || '--'

          this.info = obj
          this.userId = res.data.tbEnrollmentRoundInfos[0].userId
          this.padUserInfo = res.data
          localStorage.setItem('PAD_USER_INFO', JSON.stringify(this.padUserInfo))
          localStorage.setItem('WX_TOKEN', res.data.token)
          // 清除本地存储的考场数据，因为用户已成功登录
          localStorage.removeItem('EXAM_ROOM_DATA')
          this.dialogVisible = true
          console.log('弹窗状态:', this.dialogVisible)
          console.log('用户信息:', this.info)
        } else {
          this.$message.error(res.message || '获取用户信息失败')
        }
        this.loading = false
      }).catch(error => {
        console.log('请求错误:', error)
        this.loading = false
      })
    },
    closeFn () {
      this.dialogVisible = false
    },
    confirmFn () {
      this.saveSignStatus()
    },
    saveSignStatus () {
      saveSignStatus({ id: this.padUserInfo.tbEnrollmentRoundInfos[0].id }).then(res => {
        console.log('res', res)
        if (res.code === 200) {
          this.$router.push({ path: '/userAnswerFinal3round2', query: { season: this.queryForm.season, activityType: this.queryForm.activityType, raceSchedule: this.queryForm.raceSchedule, group: this.group, level: this.padUserInfo.level, phase: '2' } })
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    // 重选考场处理
    handleReselect () {
      this.isSelectExamRoom = false
    },
    // 获取弹窗宽度
    getDialogWidth () {
      const screenWidth = window.innerWidth
      if (screenWidth < 768) {
        return '90%'
      } else if (screenWidth < 1024) {
        return '90%'
      } else if (screenWidth < 1440) {
        return '60%'
      } else {
        return '50%'
      }
    },
    getEn (key) {
      return key === '姓 名' ? 'Name' : key === '手 机 号' ? 'Phone' : key === '年 级' ? 'Grade' : key === '学 校' ? 'School' : key === '比赛号码' ? 'Race Number' : ''
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    gradeFormatter (grade) {
      console.log('grade', grade)
      console.log('dict_grade', this.dict_grade)
      return grade ? this.dict_grade.find(item => Number(item.dictCode) === grade).dictLabel : '--'
    },
    levelFormatter (level, type) {
      return this.dict_group.find(item => item.dictCode === level)[type]
    }
  }
}
</script>
<style scoped lang="less">
.container {
    width: 100vw;
    height: 100vh;
}
.season2-logo {
    position: absolute;
    left: 40px;
    right: 40px;
    top: 36px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .img {
        height: 40px;
        width: auto;
    }
}
.screen {
    // width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    color: #000;
    font-family: "regular";
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}
.season2 {
    // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/season2bg.png);
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/2025/season3_bg_pure.jpg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .flex-box {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow-x: hidden;
        overflow-y: hidden;
    }
}
// 表单容器样式
.form-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(255, 255, 255, 0.9);
    border-radius: 16px;
    padding: 30px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(10px);
    max-width: 90vw;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 25px;
        border-radius: 14px;
    }

    @media (max-width: 480px) {
        padding: 20px;
        border-radius: 12px;
        width: 85vw;
    }

    @media (max-width: 320px) {
        padding: 15px;
        border-radius: 10px;
        width: 90vw;
    }

    .form-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        @media (max-width: 480px) {
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 15px;
        }

        &:last-child {
            margin-bottom: 0;
        }

        label {
            font-size: 22px;
            font-weight: 500;
            color: #333;
            margin-right: 15px;
            min-width: 70px;

            @media (max-width: 768px) {
                font-size: 20px;
                margin-right: 12px;
                min-width: 65px;
            }

            @media (max-width: 480px) {
                font-size: 18px;
                margin-right: 0;
                margin-bottom: 8px;
                min-width: auto;
            }

            @media (max-width: 320px) {
                font-size: 16px;
                margin-bottom: 6px;
            }
        }

        .el-select {
            width: 240px;

            @media (max-width: 768px) {
                width: 220px;
            }

            @media (max-width: 480px) {
                width: 100%;
            }

            /deep/ .el-input__inner {
                border-radius: 10px;
                border: 2px solid #dcdfe6;
                background: rgba(255, 255, 255, 0.8);
                font-size: 18px;
                height: 50px;
                line-height: 50px;

                @media (max-width: 768px) {
                    height: 45px;
                    line-height: 45px;
                    font-size: 16px;
                }

                @media (max-width: 480px) {
                    height: 42px;
                    line-height: 42px;
                    font-size: 15px;
                }

                &:focus {
                    border-color: #409eff;
                }
            }

            /deep/ .el-select__caret {
                font-size: 18px;

                @media (max-width: 768px) {
                    font-size: 16px;
                }

                @media (max-width: 480px) {
                    font-size: 14px;
                }
            }
        }

        .confirm-btn {
            width: 100%;
            height: 56px;
            line-height: 56px;
            background: linear-gradient(to bottom, #0c0a03, #373633);
            color: #fff;
            font-size: 22px;
            font-family: "regular";
            border-radius: 10px;
            text-align: center;
            cursor: pointer;
            margin-top: 15px;
            transition: all 0.3s ease;

            @media (max-width: 768px) {
                height: 50px;
                line-height: 50px;
                font-size: 20px;
                margin-top: 12px;
            }

            @media (max-width: 480px) {
                height: 46px;
                line-height: 46px;
                font-size: 18px;
                margin-top: 10px;
            }

            @media (max-width: 320px) {
                height: 42px;
                line-height: 42px;
                font-size: 16px;
                margin-top: 8px;
            }

            &:hover {
                background: linear-gradient(to bottom, #373633, #0c0a03);
                transform: translateY(-2px);
                box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
            }
        }
    }
}

.input-container {
    width: 100%;
    height: 100%;
    margin: 0 auto 180px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
}

.title {
    margin: 0 0 50px 0;
    padding: 0px 40px;
    font-size: 30px;
    text-align: center;
    color: #000;
    font-weight: 500;
    line-height: 1.4;

    @media (max-width: 768px) {
        font-size: 26px;
        padding: 0px 30px;
        margin: 0 0 40px 0;
    }

    @media (max-width: 480px) {
        font-size: 22px;
        padding: 0px 20px;
        margin: 0 0 30px 0;
    }

    @media (max-width: 320px) {
        font-size: 20px;
        padding: 0px 15px;
        margin: 0 0 25px 0;
    }
}

.input {
    display: block;
    text-align: center;
    margin: 0 0 50px 0;
    width: 450px;
    height: 60px;
    border: 3px solid #000;
    border-radius: 25px;
    background-color: #fff;
    box-shadow: inset 3px 3px 20px rgba(0, 0, 0, 0.4);
    max-width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
        width: 380px;
        height: 55px;
        margin: 0 0 40px 0;
        border-radius: 22px;
    }

    @media (max-width: 480px) {
        width: 320px;
        height: 50px;
        margin: 0 0 30px 0;
        border-radius: 20px;
    }

    @media (max-width: 320px) {
        width: 280px;
        height: 45px;
        margin: 0 0 25px 0;
        border-radius: 18px;
    }

    /deep/ .el-input__inner {
        height: 100%;
        border: none;
        text-align: center;
        font-size: 32px;
        font-family: "regular";
        color: #000;
        background-color: transparent;
        letter-spacing: 6px;

        @media (max-width: 768px) {
            height: 55px;
            font-size: 28px;
            letter-spacing: 5px;
        }

        @media (max-width: 480px) {
            height: 50px;
            font-size: 24px;
            letter-spacing: 4px;
        }

        @media (max-width: 320px) {
            height: 45px;
            font-size: 20px;
            letter-spacing: 3px;
        }
    }
}
.button-group {
    display: flex;
    align-items: center;
    gap: 40px;
    flex-wrap: wrap;
    justify-content: center;

    @media (max-width: 768px) {
        gap: 30px;
    }

    @media (max-width: 480px) {
        gap: 20px;
        flex-direction: column;
        width: 100%;
        max-width: 320px;
    }

    @media (max-width: 320px) {
        gap: 15px;
        max-width: 280px;
    }
}

.reselect-btn {
    width: 220px;
    height: 65px;
    line-height: 61px;
    background: linear-gradient(to bottom, #6c757d, #495057);
    color: #fff;
    font-size: 22px;
    font-family: "regular";
    border: 3px solid #495057;
    border-radius: 65px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
        width: 200px;
        height: 60px;
        line-height: 56px;
        font-size: 20px;
        border-radius: 60px;
    }

    @media (max-width: 480px) {
        width: 100%;
        height: 55px;
        line-height: 51px;
        font-size: 18px;
        border-radius: 55px;
    }

    @media (max-width: 320px) {
        height: 50px;
        line-height: 46px;
        font-size: 16px;
        border-radius: 50px;
    }

    &:hover {
        background: linear-gradient(to bottom, #495057, #6c757d);
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
    }
}

.search {
    width: 220px;
    height: 65px;
    line-height: 61px;
    background: linear-gradient(to bottom, #0c0a03, #373633);
    color: #fff;
    font-size: 30px;
    font-family: "regular";
    border: 3px solid #000;
    border-radius: 65px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
        width: 200px;
        height: 60px;
        line-height: 56px;
        font-size: 20px;
        border-radius: 60px;
    }

    @media (max-width: 480px) {
        width: 100%;
        height: 55px;
        line-height: 51px;
        font-size: 18px;
        border-radius: 55px;
    }

    @media (max-width: 320px) {
        height: 50px;
        line-height: 46px;
        font-size: 16px;
        border-radius: 50px;
    }

    &:hover {
        background: linear-gradient(to bottom, #373633, #0c0a03);
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
    }
}
.info-panel-season2{
  height: 540px;
  border: none;
  position: relative;
  background-color: transparent;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/rankbg.png);
  background-repeat: no-repeat;
  background-size: 90% 100%;
  background-position: center;
  padding-top: 50px;
  padding-bottom: 50px;
  box-sizing: border-box;
  .info-con{
    width: 60%;
    background-color: transparent;
    color: #000;
  }
  .info-title{
    color: #fff;
  }
}
.info-panel {
  min-height: 350px;
  max-height: 80vh;
  // background-color: #cbae72;
  border-radius: 60px;
  // border: 3px solid #000;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    border-radius: 30px;
    min-height: 300px;
  }
}
.info-title{
  margin: 16px auto 10px;
  width: 100%;
  height: 70px;
  padding-top: 12px;
  box-sizing: border-box;
  // line-height: 64px;
  text-align: center;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  color: #fff;
  .cn{
    font-size: 22px;
  }
  .en{
    font-size: 16px;
  }
}
.info-title2{
  margin: 16px auto 60px;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg2.png);
  color: #000;
}
.info-con {
  min-height: 180px;
  max-height: 40vh;
  margin: 0 auto;
  background-color: #B81C25;
  color: #fff;
  font-size: 18px;
  font-family: fzcsk;
  padding: 12px;
  box-sizing: border-box;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 92%;
    border-radius: 30px;
    padding: 15px 20px;
    font-size: 16px;
  }
}
.info-item{
  display: flex;
  .key{
    font-size: 20px;
    width: 120px;
    margin-bottom: 8px;
  }
  .en{
    font-size: 14px;
  }
  .value{
    font-size: 20px;
  }
}
.info-btns {
  position: absolute;
  bottom: 72px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  gap: 20px;

  @media (max-width: 768px) {
    // flex-direction: column;
    // gap: 15px;
  }

  .btn {
    font-size: 20px;
    width: 220px;
    text-align: center;
    height: 48px;
    line-height: 48px;
    justify-content: center;
    border-radius: 48px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
      width: 180px;
      font-size: 18px;
      height: 44px;
      line-height: 40px;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
  }

  .btn1 {
    background: linear-gradient(to bottom, #0c0a03, #373633);
  }

  .btn2 {
    background-color: #b81c25;
  }
}
/deep/ .responsive-dialog {
  background: transparent !important;
  box-shadow: none !important;

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 0 !important;
    background: transparent !important;
  }

  .el-dialog__headerbtn {
    display: none !important;
  }
}

/deep/ .season2-dialog {
  margin-bottom: 0 !important;

  .el-dialog__body {
    padding: 0;
  }
}
</style>
